
import { ElectricalAspectTypeInfoBase } from './electrical-aspect.typeinfo.base';


export class ElectricalAspectTypeInfo extends ElectricalAspectTypeInfoBase {
}

export const ELECTRICAL_ASPECT_TYPE: ElectricalAspectTypeInfo = new ElectricalAspectTypeInfo();



